import { NN, NN_REGION } from '../../constants/regions';

export const isNNiNGO = (locationId: number) => {
  return [NN, NN_REGION].includes(locationId);
};
